import React, { useState, useEffect } from "react";
import { useLocation, Route, Switch, Redirect } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
// @material-ui/icons components

// core components
import AdminNavbar from "components/Navbars/AdminNavbar.js";
//import AdminNavbarAlternative from "components/Navbars/AdminNavbarAlternative.js";
import AdminFooter from "components/Footers/AdminFooter.js";
import Sidebar from "components/Sidebar/Sidebar.js";

import routes from "routes.js";
import { canAccessPos as computeCanAccessPos, isAdminUser, getLandingPath } from "utils/access";

import componentStyles from "assets/theme/layouts/admin.js";
import tenantTheme from "tenantTheme.js";
import { DESKTOP_MEDIA_QUERY } from "common/breakpoints";

const useStyles = makeStyles(componentStyles);

const Admin = () => {
  const classes = useStyles();
  const location = useLocation();
  const [sidebarOpenResponsive, setSidebarOpenResponsive] = React.useState(
    false
  );

  const useMatchMedia = (mediaQuery, initialValue) => {
    const [isMatching, setIsMatching] = useState(initialValue)
    useEffect(() => {
      const watcher = window.matchMedia(mediaQuery)
      setIsMatching(watcher.matches)
      const listener = (matches) => {
        setIsMatching(matches.matches)
      }
      if (watcher.addEventListener) {
        watcher.addEventListener('change', listener)
      } else {
        watcher.addListener(listener)
      }
      return () => {
        if (watcher.removeEventListener) {
          return watcher.removeEventListener('change', listener)
        } else {
          return watcher.removeListener(listener)
        }
      }
    }, [mediaQuery])

    return isMatching
  }

  // Shared with Sidebar.js -- the two must switch at the same width.
  const isDesktopResolution = useMatchMedia(DESKTOP_MEDIA_QUERY, true)


  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    // mainContent.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (routes) => {
    const canAccessPos = computeCanAccessPos();
    const admin = isAdminUser();
    return routes.map((prop, key) => {
      if (prop.requiresPosAccess && !canAccessPos) {
        return null;
      }
      // Non-admins get no route registered for admin-only screens, so a direct URL
      // (e.g. /admin/dashboard) falls through to the landing redirect below.
      if (prop.adminOnly && !admin) {
        return null;
      }
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.layout === "/admin") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  // Where an unmatched path lands. Laundry users keep their own home; everyone else goes to
  // the first route they can reach — the Dashboard for admins, POS or Orders for branch and
  // permission-scoped users. Never point at a route getRoutes did not register, or the
  // redirect bounces straight back here forever; when there is nothing the user can reach
  // (no permissions, or no longer signed in) send them out to login instead.
  const renderCatchAllRedirect = () => {
    if (localStorage.getItem("userRole") == 2) {
      return <Redirect from="*" to="/admin/laundryOrders" />;
    }
    const landing = getLandingPath(routes);
    return <Redirect from="*" to={landing || "/auth"} />;
  };

  return (
    <>
      <Box display="flex">
        <Sidebar
          routes={routes}
          openResponsive={sidebarOpenResponsive}
          closeSidebarResponsive={() => setSidebarOpenResponsive(false)}
          logo={{
            innerLink: "/admin",
            imgSrc: tenantTheme.logo,
            imgAlt: tenantTheme.title,
          }}
        />
        <Box position="relative" flex="1" className={classes.mainContent}>
          {!isDesktopResolution && <AdminNavbar
            openSidebarResponsive={() => setSidebarOpenResponsive(true)}
          />}
          {/* {location.pathname === "/admin/alternative-dashboard" ? (
            <AdminNavbarAlternative
              openSidebarResponsive={() => setSidebarOpenResponsive(true)}
            />
          ) : (
            <AdminNavbar
              openSidebarResponsive={() => setSidebarOpenResponsive(true)}
            />
          )} */}
          <Switch>
            {getRoutes(routes)}
            {renderCatchAllRedirect()}

          </Switch>
          <Container
            maxWidth={false}
            component={Box}
            classes={{ root: classes.containerRoot }}
          >
            <AdminFooter />
          </Container>
        </Box>
      </Box>
    </>
  );
};

export default Admin;
